export {
  apiClient,
  apiInstitute,
  hrApiClient,
  hrApiURL,
} from '@/lib/api/clients';

export {
  API_ERROR_CODES,
  ApiError,
  assertValidObjectResponse,
  createObjectResponseInterceptor,
  getErrorMessageFromResponseData,
  getMutationErrorMessage,
  isAxiosError,
  isUnauthorizedError,
  parseApiError,
} from '@/lib/api/errors';

export { trackStatistic } from '@/lib/api/common/statistic.api';

export {
  getHrOptions,
  getOccupations,
  getProfessions,
  resolveHrOptionGkey,
  searchProfessions,
  trackCommonStatistic,
} from '@/lib/api/common/options.api';

export {
  useCommonStatistic,
  useOccupations,
  useOptions,
  useProfessions,
  useSearchProfessions,
} from '@/lib/api/common/options.queries';

export { getMembershipPrices, getPriceList } from '@/lib/api/common/price.api';

export {
  useMembershipList,
  usePriceList,
} from '@/lib/api/common/price.queries';

export {
  submitFeedback,
  type SubmitFeedbackInput,
  type SubmitFeedbackPayload,
} from '@/lib/api/common/feedback.api';
export { useSubmitFeedback } from '@/lib/api/common/feedback.queries';

export { getUsdRate } from '@/lib/api/common/exchange.api';
export {
  exchangeQueryKeys,
  useUsdRate,
} from '@/lib/api/common/exchange.queries';

export {
  createBannerActivity,
  getBannerList,
} from '@/lib/api/common/banner.api';

export {
  useBanner,
  useClickBanner,
  useCreateBannerActivity,
  useViewBanner,
} from '@/lib/api/common/banner.queries';

export { getFooter } from '@/lib/api/common/footer.api';

export {
  footerQueryKeys,
  useFooterData,
} from '@/lib/api/common/footer.queries';
